"use strict";

// Helpers
//
const isTouchDevice = () => {
	return (('ontouchstart' in window) ||
		(navigator.maxTouchPoints > 0) ||
		(navigator.msMaxTouchPoints > 0));
}

if (typeof debounce !== 'function') {
let debounce = function(fn, delay) {
	let timeout;
	return function(...args) {
	clearTimeout(timeout);
	timeout = setTimeout(() => fn.apply(this, args), delay);
	};
};
}

// Main Menu
//
if (isTouchDevice()) {
	const subMenuNavs = document.querySelectorAll('.has-sub-menu > a');
	subMenuNavs.forEach(mainMenuNav => {
		mainMenuNav.addEventListener('click', event => {
			if (!isTouchDevice()) {
				return;
			}

			subMenuNavs.forEach(item => {
				if (item === mainMenuNav) {
					return;
				}

				item.classList.remove('is-dropdown-open');
			});

			if (mainMenuNav.classList.contains('is-dropdown-open')) {
				return;
			}

			event.preventDefault();
			mainMenuNav.classList.add('is-dropdown-open');
		});
	});
}

// Menu classes based on available free space
//
const navigationMenusTopNavs = document.querySelectorAll('.navigation-main > .has-sub-menu');

const getMenuWidth = (element, initialWidth = 0) => {
	const submenu = element && element.querySelector('.navigation-sub-menu');

	if (!submenu) {
		return initialWidth;
	}


	return getMenuWidth(submenu, initialWidth + submenu.clientWidth);
}

const setMenuClasses = () => {
	const windowWidth = window.innerWidth;
	navigationMenusTopNavs.forEach(navigationMenusTopNav => {
		if (navigationMenusTopNav.classList.contains('navigation-main-item-static')) {
			return;
		}

		navigationMenusTopNav.classList.remove('nav-open-left');
		const width = getMenuWidth(navigationMenusTopNav);

		if (navigationMenusTopNav.offsetLeft + width > windowWidth) {
			navigationMenusTopNav.classList.add('nav-open-left');
		}
	});
}

setMenuClasses();

let resizeTimer;

window.addEventListener('resize', () => {
	clearTimeout(resizeTimer);
	resizeTimer = setTimeout(() => {
		setMenuClasses();
	}, 350);
});

// Mobile menu
//
const mobileMenuWrap = document.querySelector('.head-slot-nav-mobile-link-wrapper');
const mobileNavWrap = document.querySelector('.navigation-mobile-wrap');
const mobileMenuToggle = document.querySelector('.head-slot-nav-mobile-link');
const mobileMenu = document.querySelector('.mobile-menu');

const handleMobileMenuOpen = () => {
	document.body.classList.add('mobile-menu-open');
	mobileMenuToggle.ariaExpanded = 'true';
	mobileMenu.ariaHidden = 'false';
	trapFocus(mobileMenuWrap, mobileNavWrap);
}

const handleMobileMenuDismiss = () => {
	document.body.classList.remove('mobile-menu-open');
	mobileMenuToggle.ariaExpanded = 'false';
	mobileMenu.ariaHidden = 'true';
	removeTrapFocus(mobileMenuToggle);
}

const isMobileMenuOpen = () => {
	return document.body.classList.contains('mobile-menu-open');
};

document.body.addEventListener('click', (event) => {
	const { target } = event;
	const mobileNav = target.closest('.navigation-mobile-item');
	const isMobileNavButton = target.classList.contains('head-slot-nav-mobile-link') || !!target.closest('.head-slot-nav-mobile-link');

	// Handle mobile menu item expand
	if (mobileNav && mobileNav.querySelector('ul')) {
		event.preventDefault();
		mobileNav.classList.toggle('menu-item-expanded');
	}

	// Handle mobile menu show / hide
	if (isMobileNavButton && document.body.classList.contains('mobile-menu-open')) {
		handleMobileMenuDismiss();
		return;
	}

	if (isMobileNavButton) {
		handleMobileMenuOpen();
		return;
	}

	if (isMobileMenuOpen() && !target.closest('.mobile-menu')) {
		event.preventDefault();
		handleMobileMenuDismiss();
	}
});

if (mobileMenuWrap) {
	mobileMenuWrap.addEventListener('keyup', (event) => {
		if (event.code.toUpperCase() === 'ESCAPE') {
			handleMobileMenuDismiss();
		}
	});
}

// Sidebar drawer button toggle
//
const sidebarDrawerButton = document.querySelector('.button-sidebar-drawer-open');
const sidebarDrawer = document.querySelector('.page-layout-sidebar');

const handleSidebarOpen = () => {
	document.body.classList.add('page-layout-sidebar-drawer-open');
	document.body.classList.add('overflow-hidden-tablet');
	trapFocus(sidebarDrawer, sidebarDrawer.querySelector('.page-layout-sidebar-drawer-header'));
}

const handleSidebarDismiss = () => {
	document.body.classList.remove('page-layout-sidebar-drawer-open');
	document.body.classList.remove('overflow-hidden-tablet');
	removeTrapFocus(sidebarDrawerButton);
}

const isSidebarOpen = () => {
	return document.body.classList.contains('page-layout-sidebar-drawer-open');
};

if (sidebarDrawerButton && sidebarDrawer) {
	document.body.addEventListener('click', (event) => {
		const { target } = event;

		if (target.classList.contains('js-button-sidebar-drawer-dismiss')) {
			handleSidebarDismiss();
			return;
		}

		if (target.classList.contains('button-sidebar-drawer-open')) {
			handleSidebarOpen();
			return;
		}

		if (isSidebarOpen() && !target.closest('.page-layout-sidebar')) {
			handleSidebarDismiss();
			event.preventDefault();
		}
	});

	sidebarDrawer.addEventListener('keyup', (event) => {
		if (event.code.toUpperCase() === 'ESCAPE') {
			handleSidebarDismiss();
		}
	});
}

document.addEventListener('change', (event) => {
	if (event.target.parentNode.classList.contains('select-custom')) {
		const select = event.target;
		const label = select.parentNode.querySelector('label');
		label.textContent = select.options[select.selectedIndex].text;
	}
});

// Review links / scroll
//
(() => {
	const reviewsLink = document.querySelectorAll('a[href*="#product-reviews"]');
	const reviews = document.getElementById('product-reviews');

	if (reviewsLink && reviews) {
		reviewsLink.forEach(link => {
			link.addEventListener('click', () => {
				reviews.expand();
			});
		});
	}

	if (window.location.hash === '#product-reviews' && reviews) {
		setTimeout(() => {
			reviews.expand();
		}, 0);

		setTimeout(() => {
			reviews.scrollIntoView();
		}, 200);
	}
})();

// Collapsible / Expandable
//
class CollapsibleExpandable extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.collapsed = this.getAttribute('expanded') === 'false';
		this.rootElement = this.querySelector('.facet');
		this.toggleElement = this.querySelector('.facet-toggle');

		this.onToggle = this.onToggle.bind(this);
		this.toggleElement.addEventListener('click', this.onToggle);

		// Expandable list
		this.list = this.querySelector('.facet-options-list');
		this.listCollapsed = this.list && this.list.getAttribute('aria-expanded') === 'false';
		this.expandListToggle = this.querySelector('.facet-button-more');

		this.onListToggle = this.onListToggle.bind(this);

		if (this.expandListToggle) {
			this.expandListToggle.addEventListener('click', this.onListToggle);
		}
	}

	disconnectedCallback() {
		this.toggleElement.removeEventListener('click', this.onToggle);

		if (this.expandListToggle) {
			this.expandListToggle.removeEventListener('click', this.onListToggle());
		}
	}

	onToggle(event) {
		event.preventDefault();
		this.handleToggle();
	}

	collapse() {
		this.setAttribute('expanded', 'false');
		this.rootElement.setAttribute('aria-expanded', 'false');
		this.collapsed = true;
	}

	expand() {
		this.setAttribute('expanded', 'true');
		this.rootElement.setAttribute('aria-expanded', 'true');
		this.collapsed = false;
	}

	handleToggle() {
		if (this.collapsed) {
			this.expand();
		} else {
			this.collapse();
		}
	}

	onListToggle(event) {
		if (event) {
			event.preventDefault();
		}
		this.handleToggleList();
	}

	collapseList() {
		this.list.setAttribute('aria-expanded', 'false');
		this.expandListToggle.innerHTML = '&plus; Show More';
		this.listCollapsed = true;
	}

	expandList() {
		this.list.setAttribute('aria-expanded', 'true');
		this.expandListToggle.innerHTML = '&minus; Show Less';
		this.listCollapsed = false;
	}

	handleToggleList() {
		if (this.listCollapsed) {
			this.expandList();
		} else {
			this.collapseList();
		}
	}
}

customElements.define('collapsible-expandable', CollapsibleExpandable);

// Generic Modal Dialog
//
class ModalDialog extends HTMLElement {
	constructor() {
		super();
		this.querySelector('[id^="ModalClose-"]').addEventListener(
			'click',
			this.hide.bind(this)
		);
		this.addEventListener('keyup', (event) => {
			if (event.code.toUpperCase() === 'ESCAPE') {
				this.hide();
			}
		});
		if (this.classList.contains('media-modal')) {
			this.addEventListener('pointerup', (event) => {
				if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) {
					this.hide();
				}
			});
		} else {
			this.addEventListener('click', (event) => {
				if (event.target.nodeName === 'MODAL-DIALOG') {
					this.hide();
				}
			});
		}
	}

	connectedCallback() {
		if (this.moved) {
			return;
		}

		this.moved = true;
		document.body.appendChild(this);
	}

	show(opener) {
		this.openedBy = opener;
		document.body.classList.add('overflow-hidden');
		this.setAttribute('open', '');
		trapFocus(this, this.querySelector('[role="dialog"]'));
		window.pauseAllMedia();
	}

	hide() {
		document.body.classList.remove('overflow-hidden');
		this.removeAttribute('open');
		removeTrapFocus(this.openedBy);
		window.pauseAllMedia();
	}
}

customElements.define('modal-dialog', ModalDialog);

// Global modal opener
//
class ModalOpener extends HTMLElement {
	constructor() {
		super();

		const button = this.querySelector('button');

		if (!button) {
			return;
		}

		button.addEventListener('click', () => {
			const modal = document.querySelector(this.getAttribute('data-modal'));
			if (modal) {
				modal.show(button);
			}
		});
	}
}

customElements.define('modal-opener', ModalOpener);

// Variations
//
class VariantSelects extends HTMLElement {
	constructor() {
		super();
		this.addEventListener('change', this.onVariantChange);
	}

	onVariantChange() {
		this.updateOptions();
		this.updateMasterId();
		this.toggleAddButton(true, '');

		this.updatePickupAvailability();

		if (!this.currentVariant) {
			this.toggleAddButton(true, '');
			this.setUnavailable();
			this.setStockBadge(null);
		} else {
			this.updateMedia();
			this.updateURL();
			this.updateVariantInput();
			this.renderProductInfo();
		}
	}

	updateOptions() {
		this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
	}

	updateMasterId() {
		this.currentVariant = this.getVariantData().find((variant) => {
			return !variant.options.map((option, index) => {
				return this.options[index] === option;
			}).includes(false);
		});
	}

	updateMedia() {
		if (!this.currentVariant) {
			return;
		}

		if (!this.currentVariant.featured_media) {
			return;
		}

		const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
		mediaGallery.setActiveMedia(this.currentVariant.featured_media.id, mediaGallery.getAttribute('hide-variants') === 'true');
	}

	updateURL() {
		if (!this.currentVariant || this.dataset.updateUrl === 'false') {
			return;
		}
		window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);

		setTimeout(() => {
			this.closest('.product-info')?.querySelector('.uom-dropdown-select .option-label.active')?.click();
		}, 100);
		
	}

	updateVariantInput() {
		const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);

		productForms.forEach((productForm) => {
			const input = productForm.querySelector('input[name="id"]');
			input.value = this.currentVariant.id;
			input.dispatchEvent(new Event('change', { bubbles: true }));
		});
	}

	updatePickupAvailability() {
		const pickUpAvailability = document.querySelector('pickup-availability');
		if (!pickUpAvailability) {
			return;
		}

		if (this.currentVariant && this.currentVariant.available) {
			pickUpAvailability.fetchAvailability(this.currentVariant.id);
		} else {
			pickUpAvailability.removeAttribute('available');
			pickUpAvailability.innerHTML = '';
		}
	}

	renderProductInfo() {
		const productInfo = this.closest('.product-info'); // product page only
		if (productInfo) {
            productInfo.querySelectorAll('.price-item:not(s)').forEach(price => {
                price.style.display = 'none';
            });
		}
		fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
			.then((response) => response.text())
			.then((responseText) => {
				const id = `price-${this.dataset.section}`;
				const html = new DOMParser().parseFromString(responseText, 'text/html')
				const destination = document.getElementById(id);
				const source = html.getElementById(id);

				if (source && destination) {
					destination.innerHTML = source.innerHTML;
				}

				const price = document.getElementById(`price-${this.dataset.section}`);

				if (price) {
					price.classList.remove('visibility-hidden');
				}

				this.toggleAddButton(!this.currentVariant.available, window.variantStrings.outOfStock);
				this.setSku(this.currentVariant.sku);
				this.setStockBadge(this.currentVariant);


				
				if (productInfo) {
					productInfo.querySelector('.uom-dropdown-select .option-label.active')?.click();	
					setTimeout(() => {
						productInfo.querySelectorAll('.price-item:not(s)').forEach(price => {
							price.style.display = 'block';
						});
					}, 100);
				}
			});
	}

	setSku(sku) {
		const skuField = document.getElementById(`ProductSku-${this.dataset.section}`);

		if (!skuField || !sku) {
			return;
		}

		skuField.textContent = sku;
	}

	setStockBadge(variant) {
		const product = document.getElementById(`Product-${this.dataset.section}`);
		const productForm = document.getElementById(`product-form-${this.dataset.section}`);
		const stockBadge = product.querySelector('.badge-stock');

		if (!productForm || !product || !stockBadge) {
			return;
		}

		if (!variant) {
			stockBadge.parentNode.classList.add('hidden');
			return;
		}

		const { variantStock = [] } = window;
		const availableStock = variantStock.find(({ id }) => id === variant.id);

		if (availableStock == null) {
			return;
		}

		stockBadge.parentNode.classList.remove('hidden');
		const threshold = parseInt(productForm.getAttribute('data-stock-threshold'), 10);
		const stockBadgeLabel = stockBadge.querySelector('.js-stock-text');

		if (availableStock.inventory_policy === 'continue' || variant.inventory_management == null) {
			stockBadge.classList.remove('badge-stock-warning');
			stockBadge.classList.remove('badge-stock-out');
			stockBadge.classList.add('badge-stock-in');
			stockBadgeLabel.textContent = window.variantStrings.inStock;
			return;
		}

		if (!variant.available) {
			stockBadge.classList.remove('badge-stock-warning');
			stockBadge.classList.remove('badge-stock-in');
			stockBadge.classList.add('badge-stock-out');
			stockBadgeLabel.textContent = window.variantStrings.outOfStock;
			return;
		}

		if (threshold > 0 && availableStock.quantity <= threshold) {
			stockBadge.classList.remove('badge-stock-in');
			stockBadge.classList.remove('badge-stock-out');
			stockBadge.classList.add('badge-stock-warning');
			stockBadgeLabel.textContent = window.variantStrings.numberLeft.replace('[quantity]', availableStock.quantity);
			return;
		}

		stockBadge.classList.remove('badge-stock-warning');
		stockBadge.classList.remove('badge-stock-out');
		stockBadge.classList.add('badge-stock-in');
		stockBadgeLabel.textContent = window.variantStrings.inStock;
	}

	toggleAddButton(disable = true, text) {
		const productForm = document.getElementById(`product-form-${this.dataset.section}`);
		if (!productForm) {
			return;
		}

		const addButton = productForm.querySelector('[name="add"]');
		const addButtonText = productForm.querySelector('[name="add"] > span');

		if (!addButton) {
			return;
		}

		if (disable) {
			addButton.setAttribute('disabled', 'disabled');

			if (text) {
				addButtonText.textContent = text;
			}
		} else {
			addButton.removeAttribute('disabled');
			addButtonText.textContent = window.variantStrings.addToCart;
		}
	}

	setUnavailable() {
		const form = document.getElementById(`product-form-${this.dataset.section}`);
		const addButton = form.querySelector('[name="add"]');
		const addButtonText = form.querySelector('[name="add"] > span');
		const price = document.getElementById(`price-${this.dataset.section}`);
		const product = document.getElementById(`Product-${this.dataset.section}`);

		if (!addButton) {
			return;
		}

		addButtonText.textContent = window.variantStrings.unavailable;

		if (price) {
			price.classList.add('visibility-hidden');
		}
	}

	getVariantData() {
		this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}
}

if (!customElements.get('variant-selects')) {
	customElements.define('variant-selects', VariantSelects);
}

class VariantRadios extends VariantSelects {
	constructor() {
		super();
	}

	updateOptions() {
		const fieldsets = Array.from(this.querySelectorAll('fieldset'));
		this.options = fieldsets.map((fieldset) => {
			return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
		});
	}
}

customElements.define('variant-radios', VariantRadios);

// Expandable list
//
class ExpandableList extends HTMLElement {
	constructor() {
		super();

		this.elements = {
			root: this.querySelector('ul'),
			expandableNavs: this.querySelectorAll('.has-sub-menu')
		};

		if (!this.elements.expandableNavs.length) {
			return;
		}

		this.elements.expandableNavs.forEach((nav) => {
			const navLink = nav.querySelector('a');
			navLink.addEventListener('click', this.onToggle.bind(this, nav));
		});
	}

	onToggle(navElement, event) {
		event.preventDefault();
		event.stopImmediatePropagation();

		const submenu = navElement.querySelector('ul');
		const closeOthers = this.getAttribute('close-others');
		const isExpanded = submenu.getAttribute('aria-expanded') === 'true';

		if (isExpanded) {
			this.onContract(navElement)
		} else {
			this.onExpand(navElement);

			if (closeOthers) {
				const closestRoot = navElement.closest('ul');
				const siblings = [...closestRoot.querySelectorAll(':scope > .has-sub-menu')].filter(item => {
					return item !== navElement;
				});
				siblings.forEach(this.onContract);
			}
		}
	}

	onExpand(element) {
		const submenu = element.querySelector('ul');
		element.classList.add('is-expanded');
		submenu.setAttribute('aria-expanded', 'true');
	}

	onContract(element) {
		const submenu = element.querySelector('ul');
		element.classList.remove('is-expanded');
		submenu.setAttribute('aria-expanded', 'false');
	}
}

customElements.define('expandable-list', ExpandableList);

// Quantity Input
//
class QuantityInput extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector('input');
		this.changeEvent = new Event('change', { bubbles: true })

		this.querySelectorAll('button').forEach(
			(button) => button.addEventListener('click', this.onButtonClick.bind(this))
		);
	}

	onButtonClick(event) {
		event.preventDefault();
		const previousValue = this.input.value;

		event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
		if (previousValue !== this.input.value) {
			this.input.dispatchEvent(this.changeEvent);
		}
	}
}

customElements.define('quantity-input', QuantityInput);

class CartRemoveButton extends HTMLElement {
	constructor() {
		super();
		this.addEventListener('click', (event) => {
			event.preventDefault();
			const cartItems = this.closest('cart-items');
			const miniCart = this.closest('mini-cart');

			if (cartItems) {
				cartItems.updateQuantity(this.dataset.index, 0);
			}

			if (miniCart) {
				miniCart.updateQuantity(this.dataset.index, 0);
			}
		});
	}
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
	constructor() {
		super();

		this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

		this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
			.reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

		this.debouncedOnChange = debounce((event) => {
			this.onChange(event);
		}, 500);

		this.addEventListener('change', this.debouncedOnChange.bind(this));
	}

	onChange(event) {
		forceUpdateForPrices()
		this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
	}

	getSectionsToRender() {
		return [
			{
				id: 'main-cart-items',
				section: document.getElementById('main-cart-items').dataset.id,
				selector: '.js-contents',
			},
			{
				id: 'mini-cart-toggle',
				section: 'mini-cart-toggle',
				selector: '.shopify-section'
			},
			{
				id: 'cart-live-region-text',
				section: 'cart-live-region-text',
				selector: '.shopify-section'
			},
			{
				id: 'main-cart-footer',
				section: document.getElementById('main-cart-footer').dataset.id,
				selector: '.js-contents',
			}
		];
	}

	updateQuantity(line, quantity, name) {
		this.enableLoading(line);

		const body = JSON.stringify({
			line,
			quantity,
			sections: this.getSectionsToRender().map((section) => section.section),
			sections_url: window.location.pathname
		});

		fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
			.then((response) => {
				return response.text();
			})
			.then((state) => {
				const parsedState = JSON.parse(state);
				this.classList.toggle('is-empty', parsedState.item_count === 0);
				const cartFooter = document.getElementById('main-cart-footer');

				if (cartFooter) {
					cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
				}

				this.getSectionsToRender().forEach((section => {
					const elementToReplace =
						document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

					elementToReplace.innerHTML =
						this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
				}));

				this.updateLiveRegions(line, parsedState.item_count);
				const lineItem = document.getElementById(`CartItem-${line}`);
				if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
					lineItem.querySelector(`[name="${name}"]`).focus();
				}
				this.disableLoading();
			}).then(() => {
				forceUpdateForPrices()
			}).catch(() => {
				this.querySelectorAll('.cart-item-loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
				this.setError(window.cartStrings.error);
				forceUpdateForPrices()

				this.disableLoading();
			});
	}

	setError(error) {
		document.getElementById('cart-errors').textContent = error;
	}

	updateLiveRegions(line, itemCount) {
		if (this.currentItemCount === itemCount) {
			document.getElementById(`Line-item-error-${line}`)
				.querySelector('.cart-item-error-text')
				.innerHTML = window.cartStrings.quantityError.replace(
					'[quantity]',
					document.getElementById(`quantity-input-${line}`).value
				);
		}

		this.currentItemCount = itemCount;
		this.lineItemStatusElement.setAttribute('aria-hidden', true);

		const cartStatus = document.getElementById('cart-live-region-text');
		cartStatus.setAttribute('aria-hidden', false);

		setTimeout(() => {
			cartStatus.setAttribute('aria-hidden', true);
		}, 1000);
	}

	getSectionInnerHTML(html, selector) {
		return new DOMParser()
			.parseFromString(html, 'text/html')
			.querySelector(selector).innerHTML;
	}

	enableLoading(line) {
		document.getElementById('main-cart-items').classList.add('cart-items-disabled');
		this.querySelectorAll(`#CartItem-${line} .cart-item-loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
		document.activeElement.blur();
		this.lineItemStatusElement.setAttribute('aria-hidden', false);
	}

	disableLoading() {
		document.getElementById('main-cart-items').classList.remove('cart-items-disabled');
	}
}

customElements.define('cart-items', CartItems);

class MiniCart extends CartItems {
	constructor() {
		super();

		this.toggle = this.querySelector('drawer-toggle');
	}

	open(opener) {
		this.toggle.open(opener);
	}

	close() {
		this.toggle.close();
	}

	getSectionsToRender() {
		return [
			{
				id: 'mini-cart-toggle',
				section: 'mini-cart-toggle',
			},
			{
				id: 'header-mini-cart-content',
				section: 'header-mini-cart-content',
			},
			{
				id: 'header-mini-cart-footer',
				section: 'header-mini-cart-footer',
			},
		]
	}

	getSectionInnerHTML(html, selector = '.shopify-section') {
		return new DOMParser()
			.parseFromString(html, 'text/html')
			.querySelector(selector).innerHTML;
	}

	renderContents(parsedState) {
		this.getSectionsToRender().forEach((section => {
			document.getElementById(section.id).innerHTML =
				this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
		}));
		this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
			.reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);
	}

	setError(error) {
		document.getElementById('mini-cart-error').textContent = error;
	}

	enableLoading() {
		this.querySelector('.mini-cart-wrap').classList.add('loading');
	}

	disableLoading() {
		this.querySelector('.mini-cart-wrap').classList.remove('loading');
	}

	updateLiveRegions(line, itemCount) {
		if (this.currentItemCount === itemCount) {
			document.getElementById(`MiniCart-Line-item-error-${line}`)
				.querySelector('.cart-item-error-text')
				.innerHTML = window.cartStrings.quantityError.replace(
					'[quantity]',
					document.getElementById(`Mini-Cart-Quantity-${line}`).value
				);
		}

		this.currentItemCount = itemCount;
	}
}

customElements.define('mini-cart', MiniCart);

// Language & Country selectors.
//
class LocalizationForm extends HTMLElement {
	constructor() {
		super();
		this.elements = {
			input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
			button: this.querySelector('button'),
			dropdown: this.querySelector('.dropdown'),
			panel: this.querySelector('.dropdown-list-wrap'),
		};
		this.elements.button.addEventListener('click', this.openSelector.bind(this));
		this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
		this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

		this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
	}

	hidePanel() {
		this.elements.button.blur();
		this.elements.dropdown.setAttribute('aria-expanded', 'false');
		this.elements.button.setAttribute('aria-expanded', 'false');
		this.elements.panel.setAttribute('aria-hidden', 'true');
	}

	onContainerKeyUp(event) {
		if (event.code.toUpperCase() !== 'ESCAPE') {
			return;
		}

		this.hidePanel();
		this.elements.button.focus();
	}

	onItemClick(event) {
		event.preventDefault();
		const form = this.querySelector('form');
		this.elements.input.value = event.currentTarget.dataset.value;
		if (form) {
			form.submit();
		}
	}

	toggleSelector() {
		if (this.isOpen()) {
			this.hidePanel();
			return;
		}

		this.elements.button.focus();
		this.elements.panel.setAttribute('aria-hidden', 'false');
		this.elements.button.setAttribute('aria-expanded', 'true');
		this.elements.dropdown.setAttribute('aria-expanded', 'true');
	}

	isOpen() {
		return this.elements.panel.getAttribute('aria-hidden') === 'false';
	}

	openSelector() {
		this.elements.button.focus();
		this.elements.panel.setAttribute('aria-hidden', (this.elements.button.getAttribute('aria-hidden') === 'true'));
		this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
		this.elements.dropdown.setAttribute('aria-expanded', (this.elements.dropdown.getAttribute('aria-expanded') === 'false'));
	}

	closeSelector(event) {
		const shouldClose = event.relatedTarget && (event.relatedTarget.nodeName === 'BUTTON' || event.relatedTarget.nodeName === 'MAIN');
		if (event.relatedTarget === null || shouldClose) {
			this.hidePanel();
		}
	}
}

customElements.define('localization-form', LocalizationForm);

class TabsComponent extends HTMLElement {
	constructor() {
		super();
	}

	setActiveTab(handle) {
		this.querySelectorAll('[data-handle]').forEach(tab => {
			tab.setAttribute('aria-hidden', 'true');

			if (tab.getAttribute('data-handle') === handle) {
				const carouselComponent = tab.querySelector('carousel-slider');
				tab.setAttribute('aria-hidden', 'false');

				if (carouselComponent) {
					carouselComponent.flickity.resize();
				}
			}
		});
	}
}

customElements.define('tabs-component', TabsComponent);

class TabsNavigation extends HTMLElement {
	constructor() {
		super();

		this.sliderId = this.getAttribute('for');
		this.navs = this.querySelectorAll('a, button');
		this.navs.forEach(nav => {
			nav.addEventListener('click', this.onNavigationClick.bind(this, nav));
		});
	}

	onNavigationClick(element, event) {
		event.preventDefault();
		this.setActiveTab(element);
	}

	setActiveTab(nav) {
		const target = nav.getAttribute('data-collection-handle');
		const tabsComponent = document.querySelector(`#${this.sliderId}`);

		if (!tabsComponent) {
			return;
		}

		tabsComponent.setActiveTab(target);

		this.navs.forEach(element => {
			if (element === nav) {
				element.classList.add('is-active');
			} else {
				element.classList.remove('is-active');
			}
		});
	}
}

customElements.define('tabs-navigation', TabsNavigation);

class DeferredMedia extends HTMLElement {
	constructor() {
		super();
		const poster = this.querySelector('[id^="Deferred-Poster-"]');

		if (!poster) {
			return;
		}

		poster.addEventListener('click', this.loadContent.bind(this));
	}

	loadContent(focus = true) {
		window.pauseAllMedia();

		if (!this.getAttribute('loaded')) {
			const content = document.createElement('div');
			content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

			this.setAttribute('loaded', true);
			const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
			if (focus) {
				deferredElement.focus();
			}
		}
	}
}

customElements.define('deferred-media', DeferredMedia);

// Drawers
//
class DrawerModal extends HTMLElement {
	constructor() {
		super();
		this.bodyClass = this.getAttribute('body-class');
		this.isOpen = false;

		this.addEventListener('keyup', (event) => {
			if (event.code.toUpperCase() === 'ESCAPE') {
				this.close();
			}
		});
	}

	open(opener) {
		this.isOpen = true;
		this.openedBy = opener;
		document.body.classList.add(this.bodyClass);
		document.body.classList.add('drawer-open');
	}

	close() {
		this.isOpen = false;
		document.body.classList.remove(this.bodyClass);
		document.body.classList.remove('drawer-open');

		if (this.openedBy) {
			removeTrapFocus(this.openedBy);
		}
	}
}

customElements.define('drawer-modal', DrawerModal);

class DrawerToggle extends HTMLElement {
	constructor() {
		super();
		this.toggleElement = this.querySelector('a') || this.querySelector('button');
		this.bodyClass = this.getAttribute('body-class');
		this.preventOpen = this.getAttribute('prevent-open') === 'true';

		if (this.preventOpen) {
			return;
		}

		this.toggleElement.addEventListener('click', (event) => {
			event.preventDefault();
			this.handleToggle();
		});
	}

	handleToggle(opener) {
		const drawer = document.querySelector(`#${this.getAttribute('for')}`);

		if (drawer.isOpen) {
			this.close();
		} else {
			this.open(opener);
		}
	}

	open(opener) {
		const drawer = document.querySelector(`#${this.getAttribute('for')}`);

		if (drawer) {
			drawer.open(opener || this.toggleElement);
			const drawerHeader = drawer.querySelector('.drawer-header');
			trapFocus(drawer, drawerHeader);
		}
	}

	close() {
		const drawer = document.querySelector(`#${this.getAttribute('for')}`);

		if (drawer && drawer.close) {
			drawer.close();
		}
	}
}

customElements.define('drawer-toggle', DrawerToggle);

document.body.addEventListener('click', (event) => {
	if (!document.body.classList.contains('drawer-open')) {
		return;
	}

	if (event.target.closest('.drawer')) {
		return;
	}

	if (event.target.closest('drawer-toggle')) {
		return;
	}

	// Close all drawers
	[...document.querySelectorAll('.drawer')].forEach((drawer) => {
		const dismiss = drawer.querySelector('drawer-toggle');

		if (dismiss) {
			dismiss.close();
		}
	});
});

// Focus trap
function getFocusableElements(container) {
	return Array.from(
		container.querySelectorAll(
			"summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
		)
	);
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
	var elements = getFocusableElements(container);
	var first = elements[0];
	var last = elements[elements.length - 1];

	removeTrapFocus();

	trapFocusHandlers.focusin = (event) => {
		if (
			event.target !== container &&
			event.target !== last &&
			event.target !== first
		)
			return;

		document.addEventListener('keydown', trapFocusHandlers.keydown);
	};

	trapFocusHandlers.focusout = function () {
		document.removeEventListener('keydown', trapFocusHandlers.keydown);
	};

	trapFocusHandlers.keydown = function (event) {
		if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
		// On the last focusable element and tab forward, focus the first element.
		if (event.target === last && !event.shiftKey) {
			event.preventDefault();
			first.focus();
		}

		//  On the first focusable element and tab backward, focus the last element.
		if (
			(event.target === container || event.target === first) &&
			event.shiftKey
		) {
			event.preventDefault();
			last.focus();
		}
	};

	document.addEventListener('focusout', trapFocusHandlers.focusout);
	document.addEventListener('focusin', trapFocusHandlers.focusin);

	elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
	document.querySelector(":focus-visible");
} catch {
	focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
	const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
	let currentFocusedElement = null;
	let mouseClick = null;

	window.addEventListener('keydown', (event) => {
		if (navKeys.includes(event.code.toUpperCase())) {
			mouseClick = false;
		}
	});

	window.addEventListener('mousedown', (event) => {
		mouseClick = true;
	});

	window.addEventListener('focus', () => {
		if (currentFocusedElement) {
			currentFocusedElement.classList.remove('focused');
		}

		if (mouseClick) {
			return;
		}

		currentFocusedElement = document.activeElement;
		currentFocusedElement.classList.add('focused');

	}, true);
}

function removeTrapFocus(elementToFocus = null) {
	document.removeEventListener('focusin', trapFocusHandlers.focusin);
	document.removeEventListener('focusout', trapFocusHandlers.focusout);
	document.removeEventListener('keydown', trapFocusHandlers.keydown);

	if (elementToFocus) {
		elementToFocus.focus();
	}
}

function debounce(func, wait, immediate) {
	let timeout;

	return function executedFunction() {
		const context = this;
		const args = arguments;

		const later = function () {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};

		const callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);

		if (callNow) {
			func.apply(context, args);
		}
	};
}

function fetchConfig(type = 'json') {
	return {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
	};
}

function pauseAllMedia() {
	document.querySelectorAll('.js-youtube').forEach((video) => {
		video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
	});
	document.querySelectorAll('.js-vimeo').forEach((video) => {
		video.contentWindow.postMessage('{"method":"pause"}', '*');
	});
	document.querySelectorAll('video').forEach((video) => video.pause());
	document.querySelectorAll('product-model').forEach((model) => {
		if (model.modelViewerUI) {
			model.modelViewerUI.pause();
		}
	});
}

(function () {
	// We wrap each RTE table by a specific class to allow wrapping
	document.querySelectorAll('.rte table').forEach(function (table) {
		table.outerHTML = '<div class="table-wrapper">' + table.outerHTML + '</div>';
	});
	document.querySelectorAll('.rte iframe').forEach(function (iframe) {
		// We scope the wrapping only for YouTube and Vimeo
		if (iframe.src.indexOf('youtube') !== -1 || iframe.src.indexOf('youtu.be') !== -1 || iframe.src.indexOf('vimeo') !== -1) {
			iframe.outerHTML = '<div class="video-wrapper">' + iframe.outerHTML + '</div>'; // Re-set the src attribute on each iframe after page load for Chrome's "incorrect iFrame content on 'back'" bug.
			// https://code.google.com/p/chromium/issues/detail?id=395791. Need to specifically target video and admin bar

			iframe.src = iframe.src;
		}
	});
})();


document.addEventListener('DOMContentLoaded', function () {
	document.querySelectorAll('.product-quantity input[type="text"][name="quantity"]').forEach(item => {
		const itemWrapper = item.closest('[wishlist-item]')
		item.addEventListener('change', function () {
			if (itemWrapper) {
				itemWrapper.querySelectorAll('form input[name="quantity"').forEach(qtyInput => {
					qtyInput.value = item.value
				})
			}
		})
	})

	const pageTitle = document.querySelector('.page-title')
	if (pageTitle) {
		if (`${pageTitle.textContent}`.toLowerCase().includes('wishlist')) {
			document.querySelectorAll('.container-narrow').forEach(item => {
				item.classList.remove('container-narrow')
			})
		}
	}


	let wishlistButtons = document.querySelectorAll('.add-to-wishlist');

	wishlistButtons.forEach(function (button) {
		button.addEventListener('click', function (e) {
			e.preventDefault();

			if (!window.customerId) {
                window.location.href = `/account/login`;
				return
			}

			const productId = button.getAttribute('data-product-id');
			if (productId) {
				let variantId = null
				let uomValue = null
				const productForm = button.closest('form');
				if (productForm) {
					const input = productForm.querySelector('.selected-variant-id') || (productForm.querySelector('.default-variant-id') || productForm.querySelector('input[name="id"]'));
					if (input) {
						variantId = input.value;
					}

					const selectedUOM = productForm.querySelector('.selected-uom')
					if (selectedUOM) {
						uomValue = selectedUOM.value
					}
				}
				const productHandle = button.getAttribute('data-handle');
				if (button.textContent.toLowerCase().includes('remove')) {
					button.dataset.uom = uomValue
					removeFromWishList(button.dataset).then((data) => {
						const splashMessage = document.querySelector('.splash-messages')
						if (splashMessage) {
							if (splashMessage.hasAttribute('hidden')) {
								splashMessage.removeAttribute('hidden');

								splashMessage.textContent = ''
								let newElement = document.createElement('div');
								newElement.classList.add('form-status', 'form-status-error');
								newElement.textContent = 'Product Removed from Wishlist!';
								splashMessage.appendChild(newElement)
								setTimeout(function () {
									splashMessage.setAttribute('hidden', '')
								}, 5000)
							}
						}
						button.textContent = 'Add to Wishlist'
						button.classList.remove('added')
					})
				} else {
					addProductToWishlist(productId, variantId, uomValue, productHandle).then((data) => {

						const splashMessage = document.querySelector('.splash-messages')
						if (splashMessage) {
							if (splashMessage.hasAttribute('hidden')) {
								splashMessage.removeAttribute('hidden');

								splashMessage.textContent = ''
								let newElement = document.createElement('div');
								newElement.classList.add('form-status', 'form-status-success');
								newElement.textContent = 'Product Added to Wishlist!';
								splashMessage.appendChild(newElement)
								setTimeout(function () {
									splashMessage.setAttribute('hidden', '')
								}, 5000)
							}
						}
						button.textContent = 'Remove from Wishlist'
						button.classList.add('added')
					})
				}
			}

		});
	});


	if (document.querySelector('.media-icon-items-grid')) {

		let featureMediaIconIntervals = []
		let active = 0
		const mediaIconItems = document.querySelector('.media-icon-items-grid');
		const wrapper = mediaIconItems.closest('.media-icon-items');
		const handleMediaIconsOnResize = () => {
			featureMediaIconIntervals.forEach((item, index) => {
				clearInterval(featureMediaIconIntervals[index])
			})

			const screenSize = document.documentElement.clientWidth
			document.querySelectorAll('.media-icon-items-grid').forEach((item, index) => {
				if (screenSize < 990) {

					featureMediaIconIntervals[index] = setInterval(() => {
						active++
						if (active === 3) {
							active = 0
						}
						item.style.marginLeft = (active * -100) + '%'
						wrapper.querySelectorAll(`.pagination .circle-item`).forEach(page => page.classList.remove('active'))
						wrapper.querySelector(`.pagination .circle-item:nth-child(${active + 1})`).classList.add('active')
					}, 3000);
				} else {
					item.removeAttribute('style')
				}
			})
		}
		window.addEventListener('resize', handleMediaIconsOnResize);
		handleMediaIconsOnResize()

		let touchStartX = 0;
		let touchEndX = 0;
		mediaIconItems.addEventListener('touchstart', (e) => {
			touchStartX = e.changedTouches[0].screenX;
		});

		mediaIconItems.addEventListener('touchend', (e) => {
			touchEndX = e.changedTouches[0].screenX;
			handleSwipeGesture();
		});

		function handleSwipeGesture() {
			const swipeThreshold = 50; // Minimum swipe distance in pixels
			const swipeDistance = touchEndX - touchStartX;
			if (swipeDistance > swipeThreshold) {
				active = active - 1
				if (active < 0) {
					active = 2
				}
			} else if (swipeDistance < -swipeThreshold) {
				active = active + 1
				if (active >= 3) {
					active = 0
				}
			}

			if (mediaIconItems) {
				mediaIconItems.style.marginLeft = (active * -100) + '%'
				handleMediaIconsOnResize()

				wrapper.querySelectorAll(`.pagination .circle-item`).forEach(page => page.classList.remove('active'))
				wrapper.querySelector(`.pagination .circle-item:nth-child(${active + 1})`).classList.add('active')
			}
		}

		wrapper.querySelectorAll(`.pagination .circle-item`).forEach(circleItem => {
			circleItem.addEventListener('click', function () {
				active = +(circleItem.getAttribute('data-index') || 1) - 1
				medaIconIitems.style.marginLeft = (active * -100) + '%'
				handleMediaIconsOnResize()

				wrapper.querySelectorAll(`.pagination .circle-item`).forEach(pageItem => pageItem.classList.remove('active'))
				circleItem.classList.add('active')
			})
		})
	}

	const tableWrappers = document.querySelectorAll('.pantrylist-table-wrapper');

	tableWrappers.forEach(tableWrapper => {
		const productColumn = tableWrapper.querySelector('.product-column')
		const topIndicator = tableWrapper.querySelector('.scroll-indicator')
		const bottomIndicator = tableWrapper.querySelector('.scroll-indicator-bottom')

		// disable scroll
		if (productColumn.querySelectorAll('[wishlist-item]').length <= 3) {
			const scrollableTable = tableWrapper.querySelector('.scrollable-table')
			if (scrollableTable) {
				scrollableTable.style.overflow = 'hidden'
			}
		}

		tableWrapper.querySelectorAll('.details-column').forEach(detailsColumn => {

			const setIndicatorWidth = () => {
				const initialPosition = productColumn ? productColumn.offsetWidth : 0
				const visibleWidth = detailsColumn.clientWidth;
				const totalWidth = detailsColumn.scrollWidth;
				const initialWidth = (visibleWidth / totalWidth) * visibleWidth;

				if (topIndicator) {
					topIndicator.style.width = initialWidth + 'px'
					topIndicator.style.left = initialPosition + 'px'
				}
				if (bottomIndicator) {
					bottomIndicator.style.width = initialWidth + 'px'
					bottomIndicator.style.left = initialPosition + 'px'
				}

				if (visibleWidth - 2 <= initialWidth) {
					bottomIndicator.style.display = 'none';
					topIndicator.style.display = 'none';
					detailsColumn.classList.add('disable-drag')
				} else {
					bottomIndicator.style.display = 'block';
					topIndicator.style.display = 'block';
					detailsColumn.classList.remove('disable-drag')
				}
			}

			const repositionIndicators = () => {
				const initialPosition = productColumn ? productColumn.offsetWidth : 0
				const scrollLeft = detailsColumn.scrollLeft
				const totalScroll = detailsColumn.scrollWidth - detailsColumn.clientWidth
				const visibleWidth = detailsColumn.clientWidth;
				const indicatorWidth = topIndicator ? topIndicator.offsetWidth : (bottomIndicator ? bottomIndicator.offsetWidth : 0)

				// percentage
				const scrolledPercent = scrollLeft / totalScroll
				const newPosition = (visibleWidth - indicatorWidth) * scrolledPercent

				if (topIndicator) {
					topIndicator.style.left = (initialPosition + newPosition) + 'px'
				}
				if (bottomIndicator) {
					bottomIndicator.style.left = (initialPosition + newPosition) + 'px'
				}
			}

			setIndicatorWidth()
			detailsColumn.addEventListener('scroll', repositionIndicators)
			window.addEventListener('resize', () => {
				setIndicatorWidth()
				repositionIndicators()
			})

			let isDown = false;
			let startX, startY, scrollLeft, scrollTop;
			detailsColumn.addEventListener('mousedown', (e) => {
				if (detailsColumn.classList.contains('disable-drag')) {
					return
				}
				isDown = true;
				detailsColumn.classList.add('active');
				startX = e.pageX - detailsColumn.offsetLeft;
				startY = e.pageY - detailsColumn.offsetTop;
				scrollLeft = detailsColumn.scrollLeft;
				scrollTop = detailsColumn.scrollTop;
				detailsColumn.style.cursor = 'grabbing';
				document.body.style.userSelect = 'none';
			});

			detailsColumn.addEventListener('mouseleave', () => {
				if (detailsColumn.classList.contains('disable-drag')) {
					return
				}
				isDown = true;
				isDown = false;
				detailsColumn.style.cursor = 'grab';
				document.body.style.userSelect = '';
			});

			detailsColumn.addEventListener('mouseup', () => {
				if (detailsColumn.classList.contains('disable-drag')) {
					return
				}
				isDown = true;
				isDown = false;
				detailsColumn.style.cursor = 'grab';
				document.body.style.userSelect = '';
			});

			detailsColumn.addEventListener('mousemove', (e) => {
				if (detailsColumn.classList.contains('disable-drag')) {
					return
				}
				isDown = true;
				if (!isDown) return;
				e.preventDefault();
				const x = e.pageX - detailsColumn.offsetLeft;
				const y = e.pageY - detailsColumn.offsetTop;
				const walkX = (x - startX) * 2;
				const walkY = (y - startY) * 2;
				detailsColumn.scrollLeft = scrollLeft - walkX;
				detailsColumn.scrollTop = scrollTop - walkY;
			});

		})
	})

	document.querySelectorAll('.pantrylist-table .scrollable-table').forEach(item => {
		item.addEventListener('scroll', function () {
			const scrollTop = item.scrollTop;
			item.querySelectorAll('.details-column .table-header').forEach(detailsColumn => {
				detailsColumn.style.top = (scrollTop < 0 ? 0 : scrollTop) + 'px';
			})
		});
	});

	const miniCartElement = document.querySelector('mini-cart');

	if (!miniCartElement) {
		console.error('Mini cart element not found.');
		return;
	}

	const miniCart = miniCartElement;

	function updateMiniCart() {
		const config = {
			method: 'POST',
			headers: {
				'X-Requested-With': 'XMLHttpRequest'
			}
		};
		delete config.headers['Content-Type'];

		const formData = new FormData();
		formData.append('sections', miniCart.getSectionsToRender().map((section) => section.id));
		formData.append('sections_url', window.location.pathname);
		config.body = formData;

		fetch('/cart', config)
			.then((response) => response.json())
			.then((response) => {
				if (response.status) {
					miniCart.setError(response.description);
					return;
				}

				miniCart.renderContents(response);
				miniCart.open();
			})
			.catch((e) => {
				console.error(e);
			});
	}

	const config = { attributes: true, childList: true, subtree: true };
	const observer = new MutationObserver(function (mutationsList, observer) {
		for (const mutation of mutationsList) {
			const target = mutation.target
			const splashMessage = document.querySelector('.splash-messages')


			if (target.hasAttribute('hidden')) {
				splashMessage.setAttribute('hidden', '');
			} else {
				if (splashMessage.hasAttribute('hidden')) {
					splashMessage.removeAttribute('hidden');
				}
			}
			splashMessage.textContent = ''
			splashMessage.appendChild(target.closest('.form-status').cloneNode(true))

			setTimeout(function () {
				splashMessage.setAttribute('hidden', '')
			}, 5000)
		}
	});


	document.querySelectorAll('.form-status').forEach(item => {
		// Start observing the target node for configured mutations
		observer.observe(item, config);
	})

	document.querySelectorAll('.pantry-list-add-to-cart').forEach(item => {
		const formId = item.getAttribute('data-id')
		if (formId) {
			const theForm = document.querySelector(`.pantrylist-table form[id="${formId}"]`)

			if (theForm) {
				// check stock
				const isOut = theForm.querySelector('.out-of-stock')
				if (isOut) {
					item.textContent = 'Out of Stock'
					item.classList.add('out-of-stock')
				} else {
					item.addEventListener('click', function (e) {
						theForm.submit()
					})
				}
			}
		}
	})
});


function updateCartIcon(count) {
	if (count > 0) {
		const cartCount = document.querySelector('.head-slot-cart-link-quantity');
		if (cartCount) {
			cartCount.textContent = count;
		} else {
			const wrapper = document.querySelector('.head-slot-nav-link.head-slot-cart-link')
			if (wrapper) {
				const cartCount = document.createElement('span')
				cartCount.classList.add('head-slot-cart-link-quantity')
				cartCount.textContent = count
				wrapper.appendChild(cartCount)
			}
		}
	}
}


document.addEventListener('DOMContentLoaded', function () {
	document.addEventListener("click", function (event) {
		const targetElement = document.querySelector(".profile-menu"); // Change to your element
		if (!targetElement.contains(event.target)) {
			document.querySelectorAll('.profile-menu').forEach(profileMenu => {
				profileMenu.classList.remove('open')
			})
		}
	});

	document.querySelectorAll('.profile-menu').forEach(parentElm => {
		if (parentElm) {
			const item = parentElm.querySelector('.clickable-icon')
			if (item) {
				item.addEventListener('click', function (e) {
					e.preventDefault()
					if (parentElm) {
						parentElm.classList.toggle('open');
					}
				})
			}
		}
	})
});

function computePriceWithTax(price, isTaxable = null) {
    if (!price) return 0
	
	// make sure price is a number
	price = parseFloat(`${price}`.replace(/,/g, ''))
	const activeVat = getActiveVat()

	let isOn = !!document.querySelector('.t-selector-option-switch')?.checked
	let vatRate = 0;
	if (typeof isTaxable === 'boolean') {
		isOn = !!isTaxable
		vatRate = isTaxable ? +activeVat?.b2b : +activeVat?.b2c
	} else {
		vatRate = +activeVat?.rate || 0
	}
	if (!isOn) return price

	const decimalRate = +vatRate / 100

	return price + (price * decimalRate)
}

function updateMiniCartDrawer(cartData) {
	let miniDrawerWrapper = document.querySelector('.mini-cart-item-list')
	if (Array.isArray(cartData.items)) {
		let itemHTML = ''

		cartData.items.forEach((item, index) => {

			const regularPrice = +item?.price / 100
			const toggleLabel = document.querySelector('.t-selector-option-switch')
			const isOn = !!toggleLabel?.checked
			const price = computePriceWithTax(regularPrice)

			itemHTML += `
				<div class="mini-cart-item" id="MiniCartItem-${index + 1}">
					<div class="mini-cart-item-image-wrap">
						<a href="${item?.url || ''}?variant=${item?.variant_id || ''}">
							<img src="${item?.image || ''}" alt="${item?.title || ''}" loading="lazy">
							<span class="visually-hidden">${item?.title || ''}</span>
						</a>
					</div>
					<div class="mini-cart-item-info">
						<p class="mini-cart-item-eyebrow">${item?.vendor || ''}</p>
						<h3 class="mini-cart-item-heading">
							<a href="${item?.url || ''}?variant=${item?.variant_id || ''}">${item?.title || ''}</a>
						</h3>
						<div class="mini-cart-item-price">
							<span class="mini-cart-item-final-price" data-cart-price="${regularPrice}">
								$${isOn ? regularPrice.toFixed(2) : price.toFixed(2)}
							</span>
							${toggleLabel ? `<span class="tax-price-helper">${isOn ? '(inc. GST)' : '(ex. GST)'}</span>` : ''}
						</div>
						<dl class="mini-cart-variations-list">
							<div class="mini-cart-variation-option">`
							if (Array.isArray(item?.options_with_values)) {
								item.options_with_values.forEach(option => {
									itemHTML += `<dt>${option?.name || ''}:</dt>
														<dd>${option?.value || ''}</dd>`
								})
							}
			itemHTML += `</div>
						</dl>
						<p class="mini-cart-variation-option">
						</p>
						<div class="mini-cart-item-actions">
							<quantity-input class="quantity-input">
								<button type="button" name="minus" class="quantity-input-button quantity-input-minus no-js-hidden">
									−
									<span class="visually-hidden">Decrease quantity for ${item?.title || ''}</span>
								</button>
								<label for="Mini-Cart-Quantity-${index + 1}" class="visually-hidden">Quantity</label>
								<input name="updates[]" type="number" class="quantity-input-field" min="1" value="${item?.quantity || 0}" id="Mini-Cart-Quantity-${index + 1}" data-index="${index + 1}" aria-label="Quantity for ${item?.title || ''}">
								<button type="button" name="plus" class="quantity-input-button quantity-input-plus no-js-hidden">
									+
									<span class="visually-hidden">Increase quantity for ${item?.title || ''}</span>
								</button>
							</quantity-input>

							<cart-remove-button id="Remove-${index + 1}" data-index="${index + 1}">
								<a href="/cart/change?id=${item?.key || ''}&quantity=0" class="mini-cart-item-remove link-text">Remove</a>
							</cart-remove-button>
						</div>

						<div class="cart-item-error" id="MiniCart-Line-item-error-${index + 1}" role="alert">
							<small class="cart-item-error-text"></small>
							<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M12.75 16.99C12.75 16.5758 12.4142 16.24 12 16.24C11.5858 16.24 11.25 16.5758 11.25 16.99H12.75ZM11.25 17C11.25 17.4142 11.5858 17.75 12 17.75C12.4142 17.75 12.75 17.4142 12.75 17H11.25ZM12.75 7C12.75 6.58579 12.4142 6.25 12 6.25C11.5858 6.25 11.25 6.58579 11.25 7H12.75ZM11.25 14C11.25 14.4142 11.5858 14.75 12 14.75C12.4142 14.75 12.75 14.4142 12.75 14H11.25ZM11.25 16.99V17H12.75V16.99H11.25ZM11.25 7V14H12.75V7H11.25ZM20.25 12C20.25 16.5563 16.5563 20.25 12 20.25V21.75C17.3848 21.75 21.75 17.3848 21.75 12H20.25ZM12 20.25C7.44365 20.25 3.75 16.5563 3.75 12H2.25C2.25 17.3848 6.61522 21.75 12 21.75V20.25ZM3.75 12C3.75 7.44365 7.44365 3.75 12 3.75V2.25C6.61522 2.25 2.25 6.61522 2.25 12H3.75ZM12 3.75C16.5563 3.75 20.25 7.44365 20.25 12H21.75C21.75 6.61522 17.3848 2.25 12 2.25V3.75Z" fill="#001A72"></path>
						</div>
					</div>
				</div>`

		})

		if (!miniDrawerWrapper) {
			miniDrawerWrapper = document.createElement('div')
			miniDrawerWrapper.classList.add('mini-cart-item-list')
			miniDrawerWrapper.innerHTML = itemHTML

			const drawerInnerWrapper = document.querySelector('.drawer-content-inner')
			if (drawerInnerWrapper) {
				drawerInnerWrapper.innerHTML = ''
				drawerInnerWrapper.appendChild(miniDrawerWrapper)
			}
		} else {
			miniDrawerWrapper.innerHTML = itemHTML
		}
		updateMiniCartFooter(cartData.items)
	}
}

function updateMiniCartFooter(items = []) {
	let totalItems = 0
	let totalPrice = 0

	items.forEach(item => {
		totalItems += +item.quantity
		totalPrice += (+item.final_line_price)
	})


	let miniCartFooter = document.createElement('div');
	miniCartFooter.className = 'mini-cart-footer';

	let miniCartTotals = document.createElement('div');
	miniCartTotals.id = 'mini-cart-totals';
	miniCartTotals.className = 'mini-cart-recap';

	let totalSpan = document.createElement('span');
	totalSpan.textContent = 'Total';

	let totalPriceSpan = document.createElement('span');
	totalPriceSpan.textContent = `$${(totalPrice / 100).toFixed(2)} AUD`;

	miniCartTotals.appendChild(totalSpan);
	miniCartTotals.appendChild(totalPriceSpan);

	let miniCartFooterActions = document.createElement('div');
	miniCartFooterActions.className = 'mini-cart-footer-actions';

	let viewCartButton = document.createElement('a');
	viewCartButton.href = '/cart';
	viewCartButton.className = 'button button-tertiary';
	viewCartButton.textContent = 'View cart';

	let viewCartButtonSpan = document.createElement('span');
	viewCartButtonSpan.className = 'angle angle-right';

	let viewCartButtonAngle = document.createElement('span');
	viewCartButtonAngle.className = 'angle-icon';
	viewCartButtonSpan.appendChild(viewCartButtonAngle);
	viewCartButton.appendChild(viewCartButtonSpan);

	let checkoutButton = document.createElement('button');
	checkoutButton.type = 'submit';
	checkoutButton.name = 'checkout';
	checkoutButton.className = 'button';
	checkoutButton.textContent = 'Check out';

	let checkoutButtonSpan = document.createElement('span');
	checkoutButtonSpan.className = 'angle angle-right';

	let checkoutButtonAngle = document.createElement('span');
	checkoutButtonAngle.className = 'angle-icon';
	checkoutButtonSpan.appendChild(checkoutButtonAngle);
	checkoutButton.appendChild(checkoutButtonSpan);

	miniCartFooterActions.appendChild(viewCartButton);
	miniCartFooterActions.appendChild(checkoutButton);

	let spinner = document.createElement('span');
	spinner.className = 'spinner-sm';

	miniCartFooter.appendChild(miniCartTotals);
	miniCartFooter.appendChild(miniCartFooterActions);
	miniCartFooter.appendChild(spinner);

	document.querySelector('#header-mini-cart-footer').innerHTML = '';
	document.querySelector('#header-mini-cart-footer').appendChild(miniCartFooter);
}

function changeQuantity(label) {
	if (!label) return;

	const container = label.closest('.product-pricing-quantity');
	if (!container) return;
	
	const input = container.querySelector('input');
	if (!input) return;

	const min = parseInt(input.min) || 1;
	const max = parseInt(input.max) || Infinity;
	let value = parseInt(input.value) || min;
  
	if (label.dataset.type === 'plus' && value < max) {
	  value++;
	} else if (label.dataset.type === 'minus' && value > min) {
	  value--;
	}
  
	input.value = value;
	updateAddToCartQuantity(input);
  }
function updateAddToCartQuantity(input) {
	if (!input) return;

	const container = input.closest('.product-pricing-quantity');
	if (!container) return;

	const button = container.parentElement.querySelector('.js-add-to-cart');
	if (button) {
		button.dataset.qty = input.value;
	}
}
function addToCart(variantId, quantity = 1, button = null) {
	if (button && button instanceof HTMLElement) {
		button.disabled = true;
	}
	fetch('/cart/add.js', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({
			id: variantId, // Variant ID, not product ID
			quantity: quantity,
		})
	})
		.then(async (data) => {
			if (+data.status === 200 || +data.status === 201) {
				showCartNotification('Product added.')
			} else {
				data = await data.json()
				showCartNotification(data?.message || 'Error adding product to cart.', false)
			}
			return fetch('/cart.js');
		})
		.then(response => response.json())
		.then(cartData => {
			updateMiniCartDrawer(cartData);
			if (Array.isArray(cartData.items)) {
				updateCartIcon(cartData.items.reduce((acc, item) => acc + item.quantity, 0));
			}

			if (button && button instanceof HTMLElement) {
				button.disabled = false;
			}
		})
		.catch(error => {
			showCartNotification('Error adding product to cart.', false)
			console.error('Error:', error)
			if (button && button instanceof HTMLElement) {
				button.disabled = false;
			}
		});

	return false;
}


function showCartNotification(message = 'Added to cart!', success = true) {
	const splashMessage = document.querySelector('.splash-messages')
	if (splashMessage) {
		if (splashMessage.hasAttribute('hidden')) {
			splashMessage.removeAttribute('hidden');

			splashMessage.textContent = ''
			let newElement = document.createElement('div');
			newElement.classList.add('form-status', success ? 'form-status-success' : 'form-status-error');
			newElement.textContent = message;
			splashMessage.appendChild(newElement)
			setTimeout(function () {
				splashMessage.setAttribute('hidden', '')
			}, 3000)
		}
	}
}
const initQuantityScript = () => {
	document.querySelectorAll('.quantity-label-button').forEach(plusMinus => {
		const parentElm = plusMinus.closest('.quantity-label');

		if (parentElm) {
			plusMinus.addEventListener('click', e => {
				setTimeout(() => {
				const field = parentElm.querySelector('.quantity-label-field');
				const input = parentElm.querySelector('.quantity-label-field-input');
				if (field && input) input.value = +field.textContent;
				}, 200);
			});
		}
	  });
	
	  const fields = document.querySelectorAll('.quantity-label-field-input, .quantity-label-field');
	
	  fields.forEach(field => {
		field.addEventListener('input', e => {
		  const clean = (e.target.value ?? e.target.textContent).replace(/[^0-9]/g, '');
		  if (e.target.value !== undefined) e.target.value = clean;
		  else e.target.textContent = clean;
		});
	
		['change', 'blur'].forEach(evt =>
		  field.addEventListener(evt, e => {
			let raw = e.target.value || e.target.textContent || '';
			let qty = Math.max(1, parseInt(raw || '0', 10));
	
			const hiddenInput = e.target.closest('[data-quantity]')?.querySelector('input[name="quantity"]');
	
			const selectedUOM = e.target.closest('.product-pricing-wrapper')?.querySelector('label.selected-uom')?.textContent;
			if (selectedUOM) {
			  const multiplier = e.target
				.closest('.product-pricing-wrapper')
				?.querySelector(`input.selected-uom[value="${selectedUOM}"]`)
				?.getAttribute('data-multiplier') || 1;
			  if (multiplier) qty = qty * +multiplier;
			}
	
			if (hiddenInput) hiddenInput.value = qty;
	
			const parent = e.target.closest('.quantity-label');
			if (parent) {
			  const labelField = parent.querySelector('.quantity-label-field');
			  const inputField = parent.querySelector('.quantity-label-field-input');
			  if (labelField && labelField !== e.target) labelField.textContent = Math.max(1, parseInt(raw || '0', 10));
			  if (inputField && inputField !== e.target) inputField.value = Math.max(1, parseInt(raw || '0', 10));
			}
	
			// Trigger updateUOM logic
			const uomDropdown = e.target.closest('[data-quantity]')?.parentElement.querySelector('uom-dropdown');
			if (uomDropdown && typeof uomDropdown.updateUom === 'function') {
			  uomDropdown.updateUom({
				preventDefault: () => {},
				target: uomDropdown.selected || {},
			  });
			}
	
			const plus = e.target.closest('[data-quantity]')?.querySelector('.quantity-label-plus');
			const minus = e.target.closest('[data-quantity]')?.querySelector('.quantity-label-minus');
			if (plus && minus) {
			  setTimeout(() => {
				plus.click();
				minus.click();
			  }, 200);
			}
		  })
		);
	  });
}

document.addEventListener('DOMContentLoaded', () => {
	initQuantityScript()
	listenForVatChange()
	forceUpdateForPrices()
	listenShowMiniCart()

	cartPageObserver()
});

function listenShowMiniCart() {
	document.querySelectorAll('.head-slot-cart-link').forEach(i => {
		i.addEventListener('click', () => {
			forceUpdateForPrices()   
		})   
	})
}

function cartPageObserver() {
	// 1. Check if current page is the cart page
	if (window.location.pathname.includes('/cart')) {
		// 2. Keep checking for the element every 300ms
		const interval = setInterval(() => {
			const el = document.querySelector('[data-cart-price]');
			if (el) {
				forceUpdateForPrices()
				clearInterval(interval);
			}
		}, 200);
	}
}
function getActiveVat() {
	if (window.vatSwitcher && window.vatSwitcher.taxConfig) {
		const country = window.vatData.country || Shopify.country || window.vatSwitcher.defaultCountry;
		const vatType = localStorage.getItem('t-selector-vat-type') || document.querySelector('[data-vat-type].active')?.dataset.vatType || 'b2c';

		const isOn = !!document.querySelector('.t-selector-option-switch')?.checked
		const vat = isOn ? (window.vatSwitcher.taxConfig[country]?.tax_amount || 0) : 0;
		const b2b = window.vatSwitcher.taxConfig[country]?.tax_amount || 0;
		return { country, vatType, rate: vat, b2b: b2b, b2c: 0 };
	} return {}
}

function listenForVatChange () {
	const toggleLabel = document.querySelector('.t-selector-option-switch')
	if (toggleLabel) {
		toggleLabel.addEventListener('change', () => {
			forceUpdateForPrices()
		})
	}
}


function forceUpdateForPrices () {

	const toggleLabel = document.querySelector('.t-selector-option-switch')
	const isOn = !!toggleLabel?.checked
	const activeCurrency = Shopify?.currency?.active || 'AUD'
	
	document.querySelectorAll('[data-cart-price], [data-minicart-price], [data-fixed-price], [data-compare-price]').forEach(item => {
		const strPrice = item.getAttribute('data-cart-price') || item.getAttribute('data-minicart-price') || item.getAttribute('data-fixed-price') || item.getAttribute('data-compare-price')
        const regularPrice = parseFloat(`${strPrice}`.replace(/,/g, ''))

		const price = computePriceWithTax(regularPrice)
		const showCurrency = item.getAttribute('data-show-currency') === 'true'

		item.textContent = `$${price.toFixed(2)}${showCurrency ? ' ' + activeCurrency : ''}`


		const helperElm = item.parentElement.querySelector('.tax-price-helper')
		if (helperElm) {
			if (toggleLabel) {
				helperElm.textContent = `${isOn ? '(inc. GST)' : '(ex. GST)'}`
			} else {
				helperElm.textContent = ''
			}
		}
	})
}
function listenForVatChange() {
	document.querySelectorAll('.t-selector-option-switch').forEach(vatSwitcher => {
		vatSwitcher.addEventListener('change', () => {
			document.querySelectorAll('.option-label.active').forEach(i => i.click())
			forceUpdateForPrices()
		})
	})
}

// Function to run when .drawer-open is toggled
function onDrawerToggle(isOpen) {
	const toggleLabel = document.querySelector('.t-selector-option-switch');
	if (toggleLabel) {
		forceUpdateForPrices()
	}
}
  
  // Watch body class changes
  const body = document.body;
  const observer = new MutationObserver(() => {
	const isOpen = body.classList.contains('drawer-open');
	onDrawerToggle(isOpen);
  });
  
  observer.observe(body, {
	attributes: true,
	attributeFilter: ['class']
  });